// Feature flags configuration
export const FEATURES = {
  AI_CHAT_WIDGET: false, // Set to false to disable AI chat functionality
  AI_AGENT_SERVICE: false, // Set to false to disable AI agent service
};

// Helper function to check if a feature is enabled
export const isFeatureEnabled = (feature) => {
  return FEATURES[feature] || false;
};

export default FEATURES; 